import { render, staticRenderFns } from "./ccm-clinic-study.vue?vue&type=template&id=fb5f4c54&"
import script from "./ccm-clinic-study.vue?vue&type=script&lang=js&"
export * from "./ccm-clinic-study.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports